import React from 'react';
import styled from 'styled-components';

import { Grid } from '@material-ui/core';

export const Card = styled(Grid)`
  padding: 0 5% 25% 5%;
`;
